import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MediaTilesContent } from '../../models/media-tiles-content.model';
import { LIB_CONFIG } from '@challenger/care/lib-config';
import { LibConfig } from '@challenger/care/models/lib-config.model';
import { GlobalElementType } from '../../enums/global-element-type-uid.enum';

@Component({
  selector: 'vm-media-tiles-section',
  templateUrl: './media-tiles-section.component.html',
  styleUrls: ['./media-tiles-section.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MediaTilesSectionComponent {
  @Input() data: MediaTilesContent;
  @Input() isPrototype: boolean;
  strapiUrl: string;
  globalElementType = GlobalElementType;

  constructor(@Inject(LIB_CONFIG) private config: LibConfig) {
    this.strapiUrl = this.config.strapiURL;
  }
}

